/* RV Couture 24 - product card enhancements.
 *
 * 1. Turns the generic "Sale" pill into the real discount figure.
 * 2. Flags sold-out cards so CSS can step them back visually.
 *
 * Horizon renders product-card badges from a Shopify-managed block, so the
 * markup cannot be edited in Liquid. We read the prices already present in
 * the card instead, which keeps this correct for every product without
 * duplicating pricing logic anywhere.
 *
 * Prices are compared as raw digit strings ("14,999.00" -> 1499900), so the
 * currency symbol, separators and decimal settings do not matter - the ratio
 * is identical whatever the store's money format is set to.
 */
(function () {
  var MIN_PCT = 5; // below this a badge is noise; leave the default label

  function digits(text) {
    var d = (text || '').replace(/[^0-9]/g, '');
    return d ? parseInt(d, 10) : 0;
  }

  function decorate() {
    var badges = document.querySelectorAll('.product-badges__badge');
    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];
      if (badge.hasAttribute('data-rvc-seen')) continue;
      badge.setAttribute('data-rvc-seen', '');

      var card = badge.closest('product-card') || badge.closest('.product-grid__card');
      if (!card) continue;

      // Sold out: flag the card, never rewrite the label.
      if (badge.textContent.toLowerCase().indexOf('sold') !== -1) {
        card.setAttribute('data-rvc-soldout', '');
        continue;
      }

      var sale = card.querySelector('.price-item--sale');
      var was = card.querySelector('.compare-at-price');
      if (!sale || !was) continue;

      var now = digits(sale.textContent);
      var before = digits(was.textContent);
      if (!now || !before || before <= now) continue;

      var pct = Math.round(((before - now) / before) * 100);
      if (pct < MIN_PCT) continue;

      badge.textContent = pct + '% OFF';
      badge.setAttribute('data-rvc-discount', String(pct));
    }
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = window.requestAnimationFrame(function () {
      pending = null;
      decorate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorate);
  } else {
    decorate();
  }

  // Collection filters, pagination and quick-add all re-render sections.
  document.addEventListener('shopify:section:load', schedule);

  if (window.MutationObserver && document.body) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          schedule();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
